import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './Form.css';
import FormFieldText from "./formFieldText/FormFieldText.jsx";
// import FormFieldRadio from "./formFieldRadio/FormFieldRadio.jsx";
import FormMessage from "./formMessage/FormMessage";
// import FormPrivacy from "./formPrivacy/FormPrivacy";
import $ from "jquery";

/**
 * Form Component
 */
export default class Form extends Component {

    /**
     * Default props.
     *
     * @type {{headerText: string, placeholder: string, thankYouResponse: string}}
     */
    static defaultProps = {
        headerText: 'Thank you for visiting Solero.com. We’d love to hear from you! Leave us a message and we’ll get back to you soon.',
        placeholder: "Placeholder",
        thankYouResponse: "Thank you for visiting Solero.com. We’ll get back to you soon."
    };

    /**
     * Prop Types
     *
     * @type {{headerText: shim, placeholder: shim, thankYouResponse: shim}}
     */
    static propTypes = {
        headerText: PropTypes.string,
        placeholder: PropTypes.string,
        thankYouResponse: PropTypes.string
    };

    /**
     * Default state.
     *
     * @type {{emailText: string, emailValid: null, firstNameText: string, firstNameValid: null, formValid: boolean, lastNameText: string, lastNameValid: null, messageText: string, messageValid: null, optInValid: boolean}}
     */
    state = {
        emailSent: false,
        emailText: '',
        emailValid: null,
        firstNameText: '',
        firstNameValid: null,
        formValid: false,
        lastNameText: '',
        lastNameValid: null,
        messageText: '',
        messageValid: null,
        optInValid: false
    };

    /**
     * Form Constructor
     *
     * @param props
     */
    constructor(props) {
        super(props);

        this.validateFirstName = this.validateFirstName.bind(this);
        this.validateLastName = this.validateLastName.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.submit = this.submit.bind(this);
        this.isEmpty = this.isEmpty.bind(this);
        this.firstNameChange = this.firstNameChange.bind(this);
        this.lastNameChange = this.lastNameChange.bind(this);
        this.emailChange = this.emailChange.bind(this);
        this.messageChange = this.messageChange.bind(this);
    }

    /**
     * Validate first name
     *
     * @param event
     */
    validateFirstName(event) {
        let formField = event.target;
        let valid = false;

        if (this.isEmpty(formField.value) === false) {
            valid = true;
        }

        this.setState({
            firstNameValid: valid,
            formValid: this.validateForm()
        });
    }

    /**
     * Validate last name
     *
     * @param event
     */
    validateLastName(event) {
        let formField = event.target;
        let valid = false;

        if (this.isEmpty(formField.value) === false) {
            valid = true;
        }

        this.setState({
            lastNameValid: valid,
            formValid: this.validateForm()
        });
    }

    /**
     * Validate email
     *
     * Regex solution - https://stackoverflow.com/questions/46155/how-can-you-validate-an-email-address-in-javascript
     *
     * @param event
     */
    validateEmail(event) {
        // eslint-disable-next-line
        let filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let formField = event.target;
        let valid = false;

        if (filter.test(formField.value)) {
            valid = true;
        }

        this.setState({
            emailValid: valid,
            formValid: this.validateForm()
        });
    }

    /**
     * Validate message
     *
     * @param event
     */
    validateMessage(event) {
        let formField = event.target;
        formField.blur();
        let valid = false;

        if (this.isEmpty(formField.value) === false) {
            valid = true;
        }

        this.setState({
            messageValid: valid,
            formValid: this.validateForm()
        });
    }

    /**
     * Validate form
     *
     * @returns {boolean}
     */
    validateForm() {
        const {firstNameValid, lastNameValid, emailValid, messageValid} = this.state;

        let formValid = false;

        if (firstNameValid === true && lastNameValid === true && emailValid === true && messageValid === true) {
            formValid = true;
        }

        return formValid;
    }

    /**
     * Util - Check if str is empty.
     *
     * @param {string} str
     * @returns {boolean}
     */
    isEmpty(str) {
        if (str === '') {
            return true;
        }

        return false;
    }

    /**
     * First name change
     *
     * @param event
     */
    firstNameChange(event) {
        this.setState({
            firstNameText: event.target.value
        });
    }

    /**
     * Last name change
     *
     * @param event
     */
    lastNameChange(event) {
        this.setState({
            lastNameText: event.target.value
        });
    }

    /**
     * Email input change
     *
     * @param event
     */
    emailChange(event) {
        this.setState({
            emailText: event.target.value
        });
    }

    /**
     * Message text change
     *
     * @param event
     */
    messageChange(event) {
        this.setState({
            messageText: event.target.value,
            messageValid: true,
            formValid: this.validateForm()
        });
    }

    /**
     * Submit button click
     *
     * @todo Add submit functionality
     */
    submit() {

        this.submitButton.focus();

        const {emailText, firstNameText, formValid, lastNameText, messageText} = this.state;

        // let formUrl = window.location.protocol + '//' + window.location.hostname + '/sendmail.php';
        //let formUrl = 'https://solero.sfclients.com/sendmail.php';
        let formUrl = 'https://99titans.com/solero/m.php';

        let data = {
            'firstName': firstNameText,
            'lastName': lastNameText,
            'email': emailText,
            'message': messageText,
            'env': 'prod'
        };

        //console.log(data);
        //console.log(formValid);

        if (formValid) {

            console.log(formValid);

            $.ajax({
                type: "POST",
                url: formUrl,
                data: data,
                dataType: 'json',
                success: function (response) {
                    console.log("Form::success()");
                    console.log(response);
                },
                error: function (errorResponse) {
                    console.log("Form::error()");
                    console.log(errorResponse);
                }
            });

            this.setState({
                emailSent: true
            })
        }
    }

    iframe() {
        return {
            __html: '<iframe src="https://services.cognitoforms.com/f/N9p_uW6-Kk64S3etpSstew?id=1" style="position:relative;width:1px;min-width:100%;*width:100%;" frameborder="0" scrolling="yes" seamless="seamless" height="600" width="100%"></iframe><script src="https://services.cognitoforms.com/scripts/embed.js"></script>'
        }
    }

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {

        const {thankYouResponse} = this.props;
        const {emailValid, emailSent, firstNameValid, lastNameValid, messageValid} = this.state;

        return (
            <section className="Form">
                {emailSent ?
                    <div><p>{thankYouResponse}</p></div> :
                    <div dangerouslySetInnerHTML={this.iframe()} />
                    }
            </section>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/page/form/Form.jsx